/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Button, Col, Container, Inline, Link, Modal, Row, Spinner, Toast, Toggle, Tooltip, Typography,
} from '@airbus/components-react';
import './CheckerFinEditComponent.scss';
import { Close } from '@airbus/icons/react';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooksTypes';
import {
  DESC_SORT_TYPE, CANCEL, UPDATE_RESULTS, MANAGE_FIN_STATUS_DESCRIPTION, SAVE,
  FIN_HISTORY_PAYLOAD_DEFAULT_COLUMNS, FIN_HISTORY_PAYLOAD_DEFAULT_ORDERBY,
} from '../../utils/constants';
import {
  clearFleetDetailSelectedFin, setCommentsFinReducer, setFinChangesStateReducer, setFinEditModalState,
} from '../../models/checkerDetailsModel/checkerDetailsSlice';
import { loadCheckerFinHistoryDetails } from '../../models/checkerDetailsModel/checkerDetailsThunk';
import CheckerFinInlineModelComponent from './CheckerFinInlineModelComponent';
import { handleFinStatusSubmit } from './CheckerFinEditModelUtils';
import { getFromLocalStore } from '../../utils/commonMethods/generalMethods';

const CheckerFinEditModalPopup = () => {
  const CheckerFinEditModalPopupDispatcher = useAppDispatch();
  const checkerDataTableState = useAppSelector((state) => state.displayCheckerDetailsTable);
  const {
    selectedFin, finEditModalState, checkerDetailFiltersSelected,
    finStatusHistory, finChangesState = [], isFinStatusUpdateLoading, isClearSelection, paginationData, commentList,
  } = checkerDataTableState;

  const featureToggleConfig = useAppSelector((state) => state.featureToggleDetails?.data);
  const featureToggle = featureToggleConfig?.airnavx_no_fin === 'true';
  const applyToggleFlag = featureToggleConfig?.bulk_update_apply_all_toggle === 'true';
  const [applyAllToggleState, setApplyAllToggleState] = useState<boolean>(false);
  const [showApplyAllToast, setShowApplyAllToast] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  useEffect(() => {
    const isLoadHistory = selectedFin.some((item: any) => item.user_id);
    if (finEditModalState && isLoadHistory) {
      const loadFinHistoryPayload = {
        operator_code_icao: [checkerDetailFiltersSelected.operator_name],
        conditions: {
          data: selectedFin.map((item: any) => ({
            id_aircraft_registration: item.id_aircraft_registration,
            fleet_fin: item.fleet_fin,
          })),
        },
        columns: FIN_HISTORY_PAYLOAD_DEFAULT_COLUMNS,
        orderBy: FIN_HISTORY_PAYLOAD_DEFAULT_ORDERBY,
        limit: Number(getFromLocalStore('apiPaginationSize')),
        sortType: DESC_SORT_TYPE,
      };
      CheckerFinEditModalPopupDispatcher(loadCheckerFinHistoryDetails(loadFinHistoryPayload)());
    }
  }, [finEditModalState]);
  // 1. helper to identify if a card's status or comment is TRULY different from original
  const getTrulyModifiedItems = () => {
    return finChangesState.filter((change: any) => {
    // Find the original data for this specific card
      const original = selectedFin.find((s: any) => (s.uniqueid && s.uniqueid === change.uniqueid)
      || (s.fleet_fin === change.fleet_fin && s.id_aircraft_registration === change.id_aircraft_registration));

      if (!original) return false;

      // A card is ONLY "Modified" if the status changed OR a comment was typed
      const statusChanged = change.fin_status && change.fin_status !== original.fin_status;
      const commentTyped = change.comment && change.comment.trim() !== '';

      return statusChanged || commentTyped;
    });
  };

  const modifiedItems = getTrulyModifiedItems();

  // 2. A card is "Fully Ready" if it has a status AND a comment
  const fullyEditedItems = modifiedItems.filter(
    (c: any) => !!c.fin_status && !!c.comment?.trim(),
  );

  // 3. ENABLE IF:
  // - We have more than 1 card to apply to
  // - EXACTLY one card has been truly modified (status or comment)
  // - That specific card is fully complete
  const isApplyAllEnabled = applyAllToggleState || (
    selectedFin.length > 1
  && modifiedItems.length === 1
  && fullyEditedItems.length === 1
  );
  const isApplyAllDisabled = !isApplyAllEnabled;

  const selectedFinChanges = finChangesState.filter((change: any) => selectedFin.some((s: any) => (s.uniqueid && s.uniqueid === change.uniqueid)
    || (s.fleet_fin === change.fleet_fin && s.id_aircraft_registration === change.id_aircraft_registration)));
  const handleApplyAllToggle = (event: React.ChangeEvent<HTMLInputElement>, value: boolean) => {
    setApplyAllToggleState(value);
    setShowApplyAllToast(value);

    if (value && fullyEditedItems.length === 1) {
      // 2. The "Leader" card
      const masterCard = fullyEditedItems[0];

      // 3. Create a NEW array where EVERY selected card gets the leader's values
      const synchronizedChanges = selectedFin.map((f: any) => ({
        ...f,
        fin_status: masterCard.fin_status,
        comment: masterCard.comment,
      }));

      // 4. Update Redux - Now all cards look the same in the UI
      CheckerFinEditModalPopupDispatcher(setFinChangesStateReducer(synchronizedChanges));
    } else if (!value) {
    // Revert to individual states if toggled off
      const resetChanges = selectedFin.map((item: any) => ({
        ...item,
        fin_status: item.fin_status,
        comment: item.comment,
      }));
      CheckerFinEditModalPopupDispatcher(setFinChangesStateReducer(resetChanges));
    }
  };

  const handleUndo = () => {
    // Revert to the original selectedFin state (not the snapshot, which may contain edited values)
    const resetChanges = selectedFin.map((item: any) => ({
      ...item,
      fin_status: item.fin_status,
      comment: item.comment,
    }));
    CheckerFinEditModalPopupDispatcher(setFinChangesStateReducer(resetChanges));
    setApplyAllToggleState(false);
    setShowApplyAllToast(false);
  };
  useEffect(() => {
    if (!finEditModalState) {
      setApplyAllToggleState(false);
      setShowApplyAllToast(false);
      setIsError(false);
    }
  }, [finEditModalState]);
  const handleCancel = () => {
    setApplyAllToggleState(false);
    CheckerFinEditModalPopupDispatcher(setFinEditModalState(!finEditModalState));
    CheckerFinEditModalPopupDispatcher(clearFleetDetailSelectedFin(!isClearSelection));
    CheckerFinEditModalPopupDispatcher(setFinChangesStateReducer([]));
    CheckerFinEditModalPopupDispatcher(setCommentsFinReducer({ commentList: [] }));
    setIsError(false);
  };

  const hasAnyFilledComment = selectedFinChanges.some((c: any) => !!c.comment?.trim());
  const filledCommentsCount = applyAllToggleState
    ? Number(hasAnyFilledComment)
    : selectedFinChanges.filter((c: any) => !!c.comment?.trim()).length;

  const requiredCommentsCount = applyAllToggleState ? 1 : selectedFin.length;
  const commentCount = Math.max(requiredCommentsCount - filledCommentsCount, 0);

  const handlerSubmitArgs = {
    checkerDetailFiltersSelected,
    checkerDataTableState,
    finChangesState,
    CheckerFinEditModalPopupDispatcher,
    paginationData,
    isClearSelection,
    commentList,
    setIsError,
    featureToggle,
    applyAllToggleState,
  };

  return (
    <Container>
      <Modal
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        className="fin-edit-modal-popup-container"
        id="fin-edit-detail-popup"
        open={finEditModalState}
      >
        <div className="modal-container">
          {isFinStatusUpdateLoading ? <Spinner size="medium" className="fin-edit-spinner" /> : <Typography />}
          <Container className={isFinStatusUpdateLoading ? 'fin-edit-disable-container' : 'fin-edit-container'}>
            <div className="header-section">
              <Row className="header-label">
                <Col xxs={6} className="header-title">
                  <Inline spacing="1-x">
                    <Typography variant="medium">{UPDATE_RESULTS}</Typography>
                  </Inline>
                </Col>
                <Col xxs={1}>
                  <Close
                    className="modal-close-icon"
                    data-testid="modal-close"
                    onClick={() => handleCancel()}
                  />
                </Col>
              </Row>
              <Row className="header-label">
                <Col>
                  <Typography variant="medium" className="header-label-description">
                    {MANAGE_FIN_STATUS_DESCRIPTION}
                  </Typography>
                </Col>
              </Row>
            </div>
            <CheckerFinInlineModelComponent
              selectedFin={selectedFin}
              finStatusHistory={finStatusHistory}
              checkerDataTableState={checkerDataTableState}
              CheckerFinEditModalPopupDispatcher={CheckerFinEditModalPopupDispatcher}
              isError={isError}
              commentCount={commentCount}
              applyAllToggleState={applyAllToggleState}
            />
            <Row className="apply-all-row">
              <Col className="apply-all-col" style={{ paddingTop: '8px' }}>
                <Inline spacing="1-x" align="center" className="apply-all-inline">
                  {isError && commentCount > 0 && (
                  <Typography className="error-message" variant="small" data-testid="error-id">
                    {`${commentCount} Mandatory fields missing`}
                  </Typography>
                  )}
                  {applyToggleFlag && (
                  <Tooltip
                    label={applyAllToggleState ? 'Your changes applied to all results' : 'Update any single record to apply changes to all. Disabled if multiple records are edited.'}
                    placement="top"
                    className="apply-all-tooltip"
                  >
                    <Toggle
                      size="medium"
                      label="Apply to all"
                      className="apply-all-toggle"
                      disabled={isApplyAllDisabled}
                      onChange={handleApplyAllToggle}
                      checked={applyAllToggleState}
                    />
                  </Tooltip>
                  )}
                </Inline>
              </Col>

              <Col style={{ display: 'flex', alignItems: 'flex-start' }}>
                {applyAllToggleState && showApplyAllToast && (
                <Toast
                  allowClose
                  inline
                  onClose={() => setShowApplyAllToast(false)}
                  variant="warning"
                  className="apply-all-toast"
                  data-testid="apply-all-toast-id"
                >
                  <div className="toast-body">
                    Your changes will apply to all open results.
                    Please verify before saving.
                    {' '}
                    <Link
                      className="toast-link"
                      inline
                      onClick={handleUndo}
                      size="small"
                      placeholder={undefined}
                      onPointerEnterCapture={undefined}
                      onPointerLeaveCapture={undefined}
                    >
                      Undo
                    </Link>
                  </div>
                </Toast>
                )}
              </Col>
              <Col className="inline-button dataSelectionPrimary" sm={2}>
                <Button
                  size="medium"
                  variant="secondary"
                  className="reset-button"
                  onClick={() => handleCancel()}
                  data-testid="modal-cancel"
                  placeholder={undefined}
                  onPointerEnterCapture={undefined}
                  onPointerLeaveCapture={undefined}
                >
                  {CANCEL}
                </Button>
                <Button
                  size="medium"
                  className="save-button"
                  data-testid="modal-validate"
                  onClick={() => {
                    if (commentCount === 0) {
                      setIsError(false);
                      handleFinStatusSubmit(handlerSubmitArgs);
                    } else {
                      setIsError(true);
                    }
                  }}
                  placeholder={undefined}
                  onPointerEnterCapture={undefined}
                  onPointerLeaveCapture={undefined}
                >
                  {SAVE}
                </Button>
              </Col>
            </Row>
          </Container>
        </div>
      </Modal>
    </Container>
  );
};
export default CheckerFinEditModalPopup;
